import createIcon from '../../createIcon';

/**
 * @component @name South
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTVMMTcuNTkgMTMuNTlMMTMgMTguMTdWMkgxMVYxOC4xN0w2LjQxIDEzLjU4TDUgMTVMMTIgMjJMMTkgMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const South = createIcon('South', [
  [
    'path',
    { d: 'M19 15L17.59 13.59L13 18.17V2H11V18.17L6.41 13.58L5 15L12 22L19 15Z', key: '11xfg6' },
  ],
]);

export default South;
